<template>
  <svg class="button__border-decor button__border-decor--right" width="13" height="53" viewBox="0 0 13 70" xmlns="http://www.w3.org/2000/svg"> <path d="M0 70H7C10.3137 70 13 67.3137 13 64V12.2086C13 10.6173 12.3679 9.09116 11.2426 7.96594L5.03407 1.75736C3.90885 0.632141 2.38272 0 0.791426 0H0V1H0.791426C2.11751 1 3.38928 1.52679 4.32696 2.46447L10.5355 8.67305C11.4732 9.61073 12 10.8825 12 12.2086V64C12 66.7614 9.76142 69 7 69H0V70Z" /></svg>
</template>

<script>
export default {
  name: "MainButtonDecorRightMedium",
};
</script>
